export default __webpack_public_path__ + "static/media/1_0002.7c101556.webp";